import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SetUrlParamsFunction, UnknownObject } from '@shared/types';

export const useURLParams = (): [urlParams: UnknownObject, setUrlParams: (newParams: UnknownObject) => void] => {
    const [currentQueryParameters, setSearchParams] = useSearchParams();
    const urlParams = useMemo(() => Object.fromEntries(currentQueryParameters.entries()), [currentQueryParameters]);

    const setUrlParams = useCallback<SetUrlParamsFunction>(
        (newParams, navigateOptions?) => {
            const newQueryParameters = new URLSearchParams();

            for (let key in newParams) {
                const value =
                    typeof newParams[key] === 'object' ? JSON.stringify(newParams[key]) : String(newParams[key]);
                newQueryParameters.set(key, value);
            }

            setSearchParams(newQueryParameters, navigateOptions);
        },
        [setSearchParams],
    );

    return [urlParams, setUrlParams];
};
